export type ChatPanePresentation = "docked" | "mobile";

type ChatPanePresentationParams = {
  isMobile: boolean;
  isBelowMd: boolean;
};

export const resolveChatPanePresentation = ({
  isMobile,
}: ChatPanePresentationParams): ChatPanePresentation => {
  if (isMobile) return "mobile";
  return "docked";
};

type DesktopChatPaneMountParams = {
  isOpen: boolean;
  isExpanded: boolean;
  presentation: ChatPanePresentation;
};

export const shouldMountDesktopChatPane = ({
  isOpen,
  isExpanded,
  presentation,
}: DesktopChatPaneMountParams): boolean =>
  isOpen && (presentation !== "mobile" || isExpanded);
